"use client";

import Link from "next/link";
import type { ReactNode } from "react";

import type { LessonLink } from "@/shared/data/lessons";
import { trackLearnProductClick } from "@/shared/utils/analytics";

interface Props {
  href: string;
  product: NonNullable<LessonLink["product"]>;
  lessonSlug: string;
  children: ReactNode;
}

export default function LearnProductLink({ href, product, lessonSlug, children }: Props) {
  return (
    <Link
      href={href}
      onClick={() =>
        trackLearnProductClick({
          product,
          destination: href,
          lesson_slug: lessonSlug,
          page_path: window.location.pathname,
        })
      }
    >
      {children}
    </Link>
  );
}
